import request from 'utils/request'

// 获取树形控件数据
export const getList = () =>
  request().get('customer/file/batchExport/listExtFields')
// 信用主管
export const getManagerList = () => request().get('bp/apply/listCManager')
// 业务类型
export const getBusinessList = () => request().get('business/list')
// 大区
export const getRegionList = data =>
  request().post('business/region/list', data)
//返回导出条件
export const getConditions = data =>
  request().post('customer/excel/conditions', data)
// 下载
export const download = data =>
  request().post(
    'customer/excel/export',
    data,
    { responseType: 'blob' },
    { timeout: 300000 },
  )
